import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

const NAV = [
  { label: "→ Dashboard", path: "/portal/dashboard" },
  { label: "→ Loads", path: "/portal/loads" },
  { label: "→ New load (Post Load)", path: "/portal/loads?new=1" },
  { label: "→ Dispatch Board", path: "/portal/dispatch" },
  { label: "→ Carriers", path: "/portal/carriers" },
  { label: "→ Accounting", path: "/portal/accounting" },
  { label: "→ Team", path: "/portal/team" },
  { label: "→ Analytics", path: "/portal/analytics" },
];

export const CommandPalette = () => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [loads, setLoads] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); }
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    if (open && loads.length === 0) api.get("/loads").then(({ data }) => setLoads(data || [])).catch(() => {});
    if (open) setQ("");
  }, [open]); // eslint-disable-line

  const go = useCallback((path) => { setOpen(false); nav(path); }, [nav]);
  if (!open) return null;

  const ql = q.toLowerCase();
  const qNum = ql.replace(/^mfg-?/, "");
  const navHits = NAV.filter((n) => !ql || n.label.toLowerCase().includes(ql));
  const loadHits = ql.length >= 2 ? loads.filter((l) =>
    String(l.load_number || "").includes(qNum) ||
    `${l.origin_city} ${l.destination_city} ${l.carrier_name || ""} ${l.broker_name || ""}`.toLowerCase().includes(ql)
  ).slice(0, 8) : [];

  return (
    <div className="fixed inset-0 z-[100] bg-black/50 flex items-start justify-center pt-[12vh]" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }} data-testid="command-palette">
      <div className="w-full max-w-xl bg-white rounded-xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} data-testid="command-palette-input"
          placeholder="Search loads by MFG #, city, carrier… or jump to a page"
          className="w-full px-4 py-3.5 text-sm outline-none border-b border-black/10" />
        <div className="max-h-[50vh] overflow-y-auto p-2">
          {loadHits.map((l) => (
            <button key={l.id} onClick={() => go(`/portal/loads/${l.id}`)} data-testid={`palette-load-${l.load_number}`}
              className="w-full text-left px-3 py-2 rounded-md hover:bg-[#0A84FF]/10 text-sm">
              <span className="font-mono font-bold text-[#0A84FF]">MFG-{l.load_number}</span>{" "}
              {l.origin_city} → {l.destination_city} <span className="text-neutral-400 text-xs">· {l.status}{l.carrier_name ? ` · ${l.carrier_name}` : ""}</span>
            </button>
          ))}
          {loadHits.length > 0 && <div className="border-t border-black/5 my-1" />}
          {navHits.map((n) => (
            <button key={n.path} onClick={() => go(n.path)}
              className="w-full text-left px-3 py-2 rounded-md hover:bg-neutral-100 text-sm font-semibold">{n.label}</button>
          ))}
        </div>
        <div className="px-4 py-2 text-[10px] text-neutral-400 border-t border-black/5">Ctrl+K to toggle · Esc to close</div>
      </div>
    </div>
  );
};
